import React, { useState } from 'react'

import PropTypes from 'prop-types'

import './flowambassador1.css'

const Flowambassador1 = (props) => {
  const [isVisible, setIsVisible] = useState(1)
  return (
    <div className={`flowambassador1-container10 ${props.rootClassName} `}>
      {isVisible === 1 && (
        <div className="flow_card">
          <div className="flowambassador1-container11">
            <div className="flowambassador1-thq-header-elm1">
              <div className="flowambassador1-container12">
                <div className="flowambassador1-container13">
                  <span className="index_black">{props.section2}</span>
                  <div className="flowambassador1-container14">
                    <span className="index_blue">{props.text1}</span>
                    <div className="flowambassador1-thq-divider-elm1"></div>
                    <span className="index_black">{props.text2}</span>
                  </div>
                </div>
                <label className="flowambassador1-thq-name-elm1 heading">
                  {props.name1}
                </label>
              </div>
              <p className="flowambassador1-thq-caption-elm1 paragraph">
                {props.caption21}
              </p>
            </div>
            <div className="flowambassador1-thq-buttons-elm10">
              <div
                onClick={() => setIsVisible(2)}
                className="flowambassador1-thq-button-elm10 flow_button"
              >
                <span className="flowambassador1-thq-text-elm10">
                  {props.text12}
                </span>
              </div>
              <div
                onClick={() => setIsVisible(7)}
                className="flowambassador1-thq-button-elm11 flow_button"
              >
                <span className="flowambassador1-thq-text-elm11">
                  {props.text17}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVisible === 2 && (
        <div className="flow_card">
          <div className="flowambassador1-thq-buttons-elm11">
            <div onClick={() => setIsVisible(1)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
              </svg>
            </div>
          </div>
          <div className="flowambassador1-container15">
            <div className="flowambassador1-thq-header-elm2">
              <div className="flowambassador1-container16">
                <span className="index_black">{props.section11}</span>
                <div className="flowambassador1-container17">
                  <span className="index_blue">{props.text4}</span>
                  <div className="flowambassador1-thq-divider-elm2"></div>
                  <span className="index_black">{props.text5}</span>
                </div>
              </div>
              <label className="flowambassador1-thq-name-elm2 heading">
                {props.name11}
              </label>
            </div>
            <div className="flowambassador1-container18">
              <div className="flowambassador1-container19">
                <div>
                  <div className="flowambassador1-container20">
                    <img
                      alt={props.imageAlt11}
                      src={props.imageSrc19}
                      className="flowambassador1-image10"
                    />
                    <span className="flow_text">{props.text31}</span>
                  </div>
                </div>
                <div>
                  <div className="flowambassador1-container21">
                    <img
                      alt={props.imageAlt21}
                      src={props.imageSrc21}
                      className="flowambassador1-image11"
                    />
                    <span className="flow_text">{props.text41}</span>
                  </div>
                </div>
                <div>
                  <div className="flowambassador1-container22">
                    <img
                      alt={props.imageAlt31}
                      src={props.imageSrc31}
                      className="flowambassador1-image12"
                    />
                    <span className="flow_text">{props.text51}</span>
                  </div>
                </div>
                <div>
                  <div className="flowambassador1-container23">
                    <img
                      alt={props.imageAlt41}
                      src={props.imageSrc41}
                      className="flowambassador1-image13"
                    />
                    <div className="flowambassador1-container24">
                      <span className="flow_text">{props.text61}</span>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="flowambassador1-container25">
                    <img
                      alt={props.imageAlt51}
                      src={props.imageSrc51}
                      className="flowambassador1-image14"
                    />
                    <div className="flowambassador1-container26">
                      <span className="flow_text">{props.text71}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flowambassador1-thq-buttons-elm12">
              <a
                href="https://www.romania.org.ro/ambassadors#ambassador"
                target="_blank"
                rel="noreferrer noopener"
                className="flowambassador1-link1"
              >
                <p className="flowambassador1-thq-caption-elm2 paragraph">
                  <span>
                    <span>{props.text6}</span>
                    <span>{props.text7}</span>
                  </span>
                  <span className="flowambassador1-text17">{props.text3}</span>
                </p>
              </a>
              <div
                onClick={() => setIsVisible(3)}
                className="flowambassador1-thq-button-elm13 flow_button"
              >
                <span className="flowambassador1-thq-text-elm17">
                  {props.text25}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVisible === 3 && (
        <div className="flow_card">
          <div className="flowambassador1-thq-buttons-elm13">
            <div onClick={() => setIsVisible(2)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
              </svg>
            </div>
          </div>
          <div className="flowambassador1-container27">
            <div className="flowambassador1-thq-header-elm3">
              <div className="flowambassador1-container28">
                <div className="flowambassador1-container29">
                  <span className="index_black">{props.section21}</span>
                  <div className="flowambassador1-container30">
                    <span className="index_blue">{props.text13}</span>
                    <div className="flowambassador1-thq-divider-elm3"></div>
                    <span className="index_black">{props.text14}</span>
                  </div>
                </div>
                <label className="flowambassador1-thq-name-elm3 heading">
                  {props.name21}
                </label>
              </div>
            </div>
            <div className="flowambassador1-container31">
              <a
                href="https://www.romania.org.ro/ambassadors#brand"
                target="_blank"
                rel="noreferrer noopener"
                className="flowambassador1-link2"
              >
                <p className="flowambassador1-thq-caption-elm3 paragraph">
                  <span>{props.text8}</span>
                  <span className="flowambassador1-text21">{props.text9}</span>
                </p>
              </a>
              <p className="flowambassador1-thq-caption-elm4 paragraph">
                {props.caption21111}
              </p>
            </div>
            <div className="flowambassador1-thq-field-elm15">
              <div className="flowambassador1-container32">
                <img
                  alt={props.imageAlt61}
                  src={props.imageSrc61}
                  className="flowambassador1-image15 flow_image"
                />
                <span className="flow_text2">
                  <span>{props.text37}</span>
                  <span className="flowambassador1-text23">{props.text38}</span>
                  <span className="flowambassador1-text24">{props.text39}</span>
                </span>
              </div>
            </div>
            <div className="flowambassador1-thq-buttons-elm14">
              <a
                href="https://www.romania.org.ro/ambassadors#strategy"
                target="_blank"
                rel="noreferrer noopener"
                className="flowambassador1-link3"
              >
                <p className="flowambassador1-thq-caption-elm5 paragraph">
                  <span>{props.text10}</span>
                  <span className="flowambassador1-text26">{props.text29}</span>
                </p>
              </a>
              <div
                onClick={() => setIsVisible(4)}
                className="flowambassador1-thq-button-elm15 flow_button"
              >
                <span className="flowambassador1-thq-text-elm19">
                  {props.text81}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVisible === 4 && (
        <div className="flow_card">
          <div className="flowambassador1-thq-buttons-elm15">
            <div onClick={() => setIsVisible(3)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
              </svg>
            </div>
          </div>
          <div className="flowambassador1-container33">
            <div className="flowambassador1-thq-header-elm4">
              <div className="flowambassador1-container34">
                <span className="index_black">{props.section31}</span>
                <div className="flowambassador1-container35">
                  <span className="index_blue">{props.text15}</span>
                  <div className="flowambassador1-thq-divider-elm4"></div>
                  <span className="index_black">{props.text16}</span>
                </div>
              </div>
              <label className="flowambassador1-thq-name-elm4 heading">
                {props.name31}
              </label>
            </div>
            <div className="flowambassador1-thq-field-elm16">
              <div className="flowambassador1-container36">
                <img
                  alt={props.imageAlt71}
                  src={props.imageSrc71}
                  className="flowambassador1-image16 flow_image"
                />
                <div className="flowambassador1-container37">
                  <span className="flow_text2">{props.text101}</span>
                  <div className="flowambassador1-container38">
                    <img
                      alt={props.imageAlt81}
                      src={props.imageSrc81}
                      className="flowambassador1-image17"
                    />
                    <span className="flow_text">{props.text111}</span>
                  </div>
                  <div className="flowambassador1-container39">
                    <img
                      alt={props.imageAlt92}
                      src={props.imageSrc91}
                      className="flowambassador1-image18"
                    />
                    <span className="flow_text">{props.text122}</span>
                  </div>
                  <div className="flowambassador1-container40">
                    <img
                      alt={props.imageAlt911}
                      src={props.imageSrc912}
                      className="flowambassador1-image19"
                    />
                    <span className="flow_text">{props.text1212}</span>
                  </div>
                  <div className="flowambassador1-container41">
                    <img
                      alt={props.imageAlt9111}
                      src={props.imageSrc9111}
                      className="flowambassador1-image20"
                    />
                    <span className="flow_text">{props.text12111}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="flowambassador1-thq-buttons-elm16">
              <div
                onClick={() => setIsVisible(5)}
                className="flowambassador1-thq-button-elm17 flow_button"
              >
                <span className="flowambassador1-thq-text-elm25">
                  {props.text91}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVisible === 5 && (
        <div className="flow_card">
          <div className="flowambassador1-thq-buttons-elm17">
            <div onClick={() => setIsVisible(4)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
              </svg>
            </div>
          </div>
          <div className="flowambassador1-container42">
            <div className="flowambassador1-thq-header-elm5">
              <div className="flowambassador1-container43">
                <span className="index_black">{props.section51}</span>
                <div className="flowambassador1-container44">
                  <span className="index_blue">{props.text19}</span>
                  <div className="flowambassador1-thq-divider-elm5"></div>
                  <span className="index_black">{props.text20}</span>
                </div>
              </div>
              <label className="flowambassador1-thq-name-elm5 heading">
                {props.name51}
              </label>
            </div>
            <div className="flowambassador1-thq-field-elm17">
              <div className="flowambassador1-container45">
                <img
                  alt={props.imageAlt131}
                  src={props.imageSrc131}
                  className="flowambassador1-image21 flow_image"
                />
                <div className="flowambassador1-container46">
                  <span className="flow_text2">{props.text181}</span>
                  <div className="flowambassador1-container47">
                    <img
                      alt={props.imageAlt141}
                      src={props.imageSrc141}
                      className="flowambassador1-image22"
                    />
                    <span className="flow_text">{props.text191}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="flowambassador1-thq-buttons-elm18">
              <div
                onClick={() => setIsVisible(6)}
                className="flowambassador1-thq-button-elm19 flow_button"
              >
                <span className="flowambassador1-thq-text-elm28">
                  {props.text171}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVisible === 6 && (
        <div className="flow_card">
          <div className="flowambassador1-thq-buttons-elm19">
            <div onClick={() => setIsVisible(5)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
              </svg>
            </div>
          </div>
          <div className="flowambassador1-container48">
            <div className="flowambassador1-thq-header-elm6">
              <div className="flowambassador1-container49">
                <span className="index_black">{props.section61}</span>
                <div className="flowambassador1-container50">
                  <span className="index_blue">{props.text21}</span>
                  <div className="flowambassador1-thq-divider-elm6"></div>
                  <span className="index_black">{props.text22}</span>
                </div>
              </div>
              <label className="flowambassador1-thq-name-elm6 heading">
                {props.name61}
              </label>
            </div>
            <div className="flowambassador1-thq-field-elm18">
              <div className="flowambassador1-container51">
                <img
                  alt={props.imageAlt151}
                  src={props.imageSrc151}
                  className="flowambassador1-image23 flow_image"
                />
                <div className="flowambassador1-container52">
                  <span className="flow_text2">{props.text211}</span>
                  <div className="flowambassador1-container53">
                    <img
                      alt={props.imageAlt161}
                      src={props.imageSrc161}
                      className="flowambassador1-image24"
                    />
                    <span className="flow_text">{props.text221}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="flowambassador1-thq-buttons-elm20">
              <div
                onClick={() => setIsVisible(7)}
                className="flowambassador1-thq-button-elm21 flow_button"
              >
                <span className="flowambassador1-thq-text-elm31">
                  {props.text201}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVisible === 7 && (
        <div className="flow_card">
          <div className="flowambassador1-thq-buttons-elm21">
            <div onClick={() => setIsVisible(6)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M854 470v84h-520l238 240-60 60-342-342 342-342 60 60-238 240h520z"></path>
              </svg>
            </div>
            <div onClick={() => setIsVisible(1)} className="flow_button">
              <svg viewBox="0 0 1024 1024" className="flow_icon">
                <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
              </svg>
            </div>
          </div>
          <div className="flowambassador1-container54">
            <div className="flowambassador1-thq-header-elm7">
              <div className="flowambassador1-container55">
                <span className="index_black">{props.section71}</span>
                <div className="flowambassador1-container56">
                  <span className="index_blue">{props.text23}</span>
                  <div className="flowambassador1-thq-divider-elm7"></div>
                  <span className="index_black">{props.text24}</span>
                </div>
              </div>
              <label className="flowambassador1-thq-name-elm7 heading">
                {props.name71}
              </label>
            </div>
            <div className="flowambassador1-container57">
              <a
                href="https://www.instagram.com/romania/"
                target="_blank"
                rel="noreferrer noopener"
                className="flowambassador1-link4"
              >
                <div className="flowambassador1-thq-field-elm19 ambassador_contact">
                  <div className="flowambassador1-container58">
                    <img
                      alt={props.imageAlt101}
                      src={props.imageSrc111}
                      className="flowambassador1-image25"
                    />
                    <div className="flowambassador1-container59">
                      <span className="flowambassador1-thq-text-elm32 flow_text">
                        {props.text2211}
                      </span>
                      <span className="flowambassador1-thq-text-elm33 flow_text">
                        {props.text2213321}
                      </span>
                    </div>
                  </div>
                  <img
                    alt={props.imageAlt111}
                    src={props.imageSrc121}
                    className="flowambassador1-image26"
                  />
                  <img
                    alt={props.imageAlt123}
                    src={props.imageSrc171}
                    className="flowambassador1-image27"
                  />
                  <img
                    alt={props.imageAlt1221}
                    src={props.imageSrc1721}
                    className="flowambassador1-image28"
                  />
                  <img
                    alt={props.imageAlt1211}
                    src={props.imageSrc1713}
                    className="flowambassador1-image29"
                  />
                  <img
                    alt={props.imageAlt172}
                    src={props.imageSrc181}
                    className="flowambassador1-image30"
                  />
                </div>
              </a>
              <a
                href="mailto:hi@romania.org.ro?subject=Hi @Romania!"
                className="flowambassador1-link5"
              >
                <div className="flowambassador1-thq-field-elm20 ambassador_contact">
                  <div className="flowambassador1-container60">
                    <img
                      alt={props.imageAlt1021}
                      src={props.imageSrc1121}
                      className="flowambassador1-image31"
                    />
                    <div className="flowambassador1-container61">
                      <span className="flowambassador1-thq-text-elm34 flow_text">
                        {props.text221322}
                      </span>
                      <span className="flowambassador1-thq-text-elm35 flow_text">
                        {props.text221333}
                      </span>
                    </div>
                  </div>
                  <img
                    alt={props.imageAlt12211}
                    src={props.imageSrc17211}
                    className="flowambassador1-image32"
                  />
                  <img
                    alt={props.imageAlt1231}
                    src={props.imageSrc1731}
                    className="flowambassador1-image33"
                  />
                  <img
                    alt={props.imageAlt12111}
                    src={props.imageSrc17111}
                    className="flowambassador1-image34"
                  />
                  <img
                    alt={props.imageAlt1711}
                    src={props.imageSrc1811}
                    className="flowambassador1-image35"
                  />
                </div>
              </a>
              <a href="tel:+40750453880" className="flowambassador1-link6">
                <div className="flowambassador1-thq-field-elm21 ambassador_contact">
                  <div className="flowambassador1-container62">
                    <img
                      alt={props.imageAlt10221}
                      src={props.imageSrc11221}
                      className="flowambassador1-image36"
                    />
                    <div className="flowambassador1-container63">
                      <span className="flowambassador1-thq-text-elm36 flow_text">
                        {props.text2213211}
                      </span>
                      <span className="flowambassador1-thq-text-elm37 flow_text">
                        {props.text2213311}
                      </span>
                    </div>
                  </div>
                  <img
                    alt={props.imageAlt111121}
                    src={props.imageSrc121121}
                    className="flowambassador1-image37"
                  />
                  <img
                    alt={props.imageAlt12221}
                    src={props.imageSrc17221}
                    className="flowambassador1-image38"
                  />
                  <img
                    alt={props.imageAlt1241}
                    src={props.imageSrc1741}
                    className="flowambassador1-image39"
                  />
                  <img
                    alt={props.imageAlt12121}
                    src={props.imageSrc17121}
                    className="flowambassador1-image40"
                  />
                  <img
                    alt={props.imageAlt1721}
                    src={props.imageSrc1821}
                    className="flowambassador1-image41"
                  />
                </div>
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

Flowambassador1.defaultProps = {
  imageSrc19: '/formula/roi_blue2.svg',
  text171: 'Continue ->',
  imageAlt92: 'image',
  text14: '07',
  imageSrc1731: '/frames/corner.svg',
  imageSrc81: '/frames/frame_shape2.svg',
  imageAlt1241: 'image',
  imageAlt12111: 'image',
  text41: 'Name  on the @Romania platform',
  imageSrc1121: '/assets/ig_blue%20copy%202-200h.png',
  text24: '07',
  imageSrc71: '/external/roi_blue.svg',
  text221322: 'hi@romania.org.ro',
  imageAlt9111: 'image',
  section21: 'Ambassadors Program',
  imageAlt12121: 'image',
  text51: 'Name on an important monument',
  text17: "I've decided ->",
  imageAlt111: 'image',
  imageSrc111: '/assets/ig_blue%20copy-200w.png',
  text19: '05',
  imageAlt51: 'image',
  imageAlt81: 'image',
  imageSrc131: '/external/roi_blue.svg',
  text8:
    'Our mission is to empower Romania via a Country Brand, Media Engine, Tourism and Tourism Promotion platforms and much more. Read all about it ',
  imageSrc11221: '/assets/ig_blue%20copy%203-200w.png',
  text61: 'Bespoke medal crafted by the State Mint',
  imageAlt1021: 'image',
  name31: 'Decide who becomes an Ambassador',
  imageSrc17221: '/frames/corner.svg',
  name61: 'Enjoy flexibility in how you contribute',
  section61: 'Ambassadors Program',
  text122:
    'You need to donate €5,000 or more for each person you wish to honor as an Ambassador.',
  imageAlt151: 'image',
  text37: 'Contribute\xA0',
  text25: 'Continue ->',
  text13: '03',
  text21: '06',
  text5: '07',
  name11: 'What you get',
  imageSrc1741: '/frames/corner.svg',
  text2211: '@romania',
  imageSrc1713: '/frames/corner.svg',
  text10: 'See how your financial contribution creates value for Romania, ',
  imageAlt11: 'image',
  imageSrc1811: '/frames/corner_arrow.svg',
  text221333: 'send us an email',
  caption21111:
    "As a non-profit, we are building value for Romania by lifting its tourism industry. Contributing to our initiative means you help boost our country's economy and you have a positive impact on Romania's tourism promotion.",
  text221:
    "We are happy to accommodate alternative donation methods according to your preference. Send us an email and we'll get it sorted.",
  imageAlt1721: 'image',
  imageAlt21: 'image',
  text4: '02',
  imageAlt172: 'image',
  section71: 'Ambassadors Program',
  imageSrc61: '/external/roi_blue.svg',
  text191:
    'When donating as a company or non-profit, please keep in mind that the title of Ambassador along with benefits can only be given to yourself or the people you choose and cannot be attributed to said company or non-profit.',
  imageSrc17211: '/frames/corner.svg',
  section31: 'Ambassadors Program',
  caption21:
    'We believe that helping build Romania’s Country Brand deserves to be recognized. Join the ranks of pioneers for driving positive change in Romania and be rewarded for your invaluable contribution with equally precious distinction.',
  text29: 'here.',
  text101:
    'Choose yourself, friends, family or colleagues or commemorate others by making them Ambassadors',
  text2213311: 'call us',
  imageSrc912: '/frames/frame_shape2.svg',
  imageSrc21: '/formula/roi_blue2.svg',
  text6: 'See the complete description of your rewards ',
  imageAlt41: 'image',
  section2: 'Ambassadors Program',
  imageSrc41: '/formula/roi_blue2.svg',
  imageSrc171: '/frames/corner.svg',
  name71: 'Get in touch to start your Ambassador journey',
  text31: 'Signed Certificate of Merit',
  text16: '07',
  text2213321: 'text us on instagram',
  imageAlt111121: 'image',
  section11: 'Ambassadors Program',
  imageAlt101: 'image',
  text38: '€5,000 or more',
  imageSrc121: '/assets/asset%2030-200w.png',
  text2213211: '+40 750 453 880',
  imageAlt61: 'image',
  imageSrc141: '/frames/frame_shape2.svg',
  text201: 'Continue ->',
  section51: 'Ambassadors Program',
  imageSrc151: '/external/roi_blue.svg',
  imageAlt12211: 'image',
  imageAlt911: 'image',
  imageSrc1821: '/frames/corner_arrow.svg',
  text71: 'Elite networking opportunities and experiences',
  name1: 'Ambassadors are the driving force for growth',
  text9: 'here.',
  imageSrc161: '/frames/frame_shape2.svg',
  text22: '07',
  imageAlt31: 'image',
  text211: 'Donate via bank transfer or other preferred methods',
  text39: ' to become an Ambassador or gift the title to others',
  text1: '01',
  imageSrc1721: '/frames/corner.svg',
  imageAlt1231: 'image',
  text2: '07',
  imageAlt1711: 'image',
  imageAlt141: 'image',
  imageSrc31: '/formula/roi_blue2.svg',
  imageSrc17111: '/frames/corner.svg',
  imageAlt161: 'image',
  imageAlt123: 'image',
  text15: '04',
  imageSrc51: '/formula/roi_blue2.svg',
  text12: 'Continue',
  rootClassName: '',
  imageSrc121121: '/assets/asset%2028-200w.png',
  imageAlt1221: 'image',
  text1212:
    'Donating for yourself means you become an Ambassador and you receive all the benefits associated.',
  imageAlt10221: 'image',
  imageAlt12221: 'image',
  text3: 'here.',
  imageAlt131: 'image',
  imageSrc91: '/frames/frame_shape2.svg',
  imageAlt1211: 'image',
  name51: 'Enjoy flexibility in how you contribute',
  imageSrc181: '/frames/corner_arrow.svg',
  text20: '07',
  imageSrc9111: '/frames/frame_shape2.svg',
  text23: '07',
  text7: ' ',
  imageSrc17121: '/frames/corner.svg',
  text111:
    'This is a way for you to honor the people around you or even celebrate the memory of someone dear to you, or someone who inspired you, with the title of Ambassador.',
  name21: 'Create positive change as an Ambassador',
  text91: 'Continue ->',
  text81: 'Continue ->',
  text181: 'Donate as a private person, company or non-profit',
  imageAlt71: 'image',
  text12111:
    'Donating for others means they become Ambassadors and they receive all the benefits associated.',
}

Flowambassador1.propTypes = {
  imageSrc19: PropTypes.string,
  text171: PropTypes.string,
  imageAlt92: PropTypes.string,
  text14: PropTypes.string,
  imageSrc1731: PropTypes.string,
  imageSrc81: PropTypes.string,
  imageAlt1241: PropTypes.string,
  imageAlt12111: PropTypes.string,
  text41: PropTypes.string,
  imageSrc1121: PropTypes.string,
  text24: PropTypes.string,
  imageSrc71: PropTypes.string,
  text221322: PropTypes.string,
  imageAlt9111: PropTypes.string,
  section21: PropTypes.string,
  imageAlt12121: PropTypes.string,
  text51: PropTypes.string,
  text17: PropTypes.string,
  imageAlt111: PropTypes.string,
  imageSrc111: PropTypes.string,
  text19: PropTypes.string,
  imageAlt51: PropTypes.string,
  imageAlt81: PropTypes.string,
  imageSrc131: PropTypes.string,
  text8: PropTypes.string,
  imageSrc11221: PropTypes.string,
  text61: PropTypes.string,
  imageAlt1021: PropTypes.string,
  name31: PropTypes.string,
  imageSrc17221: PropTypes.string,
  name61: PropTypes.string,
  section61: PropTypes.string,
  text122: PropTypes.string,
  imageAlt151: PropTypes.string,
  text37: PropTypes.string,
  text25: PropTypes.string,
  text13: PropTypes.string,
  text21: PropTypes.string,
  text5: PropTypes.string,
  name11: PropTypes.string,
  imageSrc1741: PropTypes.string,
  text2211: PropTypes.string,
  imageSrc1713: PropTypes.string,
  text10: PropTypes.string,
  imageAlt11: PropTypes.string,
  imageSrc1811: PropTypes.string,
  text221333: PropTypes.string,
  caption21111: PropTypes.string,
  text221: PropTypes.string,
  imageAlt1721: PropTypes.string,
  imageAlt21: PropTypes.string,
  text4: PropTypes.string,
  imageAlt172: PropTypes.string,
  section71: PropTypes.string,
  imageSrc61: PropTypes.string,
  text191: PropTypes.string,
  imageSrc17211: PropTypes.string,
  section31: PropTypes.string,
  caption21: PropTypes.string,
  text29: PropTypes.string,
  text101: PropTypes.string,
  text2213311: PropTypes.string,
  imageSrc912: PropTypes.string,
  imageSrc21: PropTypes.string,
  text6: PropTypes.string,
  imageAlt41: PropTypes.string,
  section2: PropTypes.string,
  imageSrc41: PropTypes.string,
  imageSrc171: PropTypes.string,
  name71: PropTypes.string,
  text31: PropTypes.string,
  text16: PropTypes.string,
  text2213321: PropTypes.string,
  imageAlt111121: PropTypes.string,
  section11: PropTypes.string,
  imageAlt101: PropTypes.string,
  text38: PropTypes.string,
  imageSrc121: PropTypes.string,
  text2213211: PropTypes.string,
  imageAlt61: PropTypes.string,
  imageSrc141: PropTypes.string,
  text201: PropTypes.string,
  section51: PropTypes.string,
  imageSrc151: PropTypes.string,
  imageAlt12211: PropTypes.string,
  imageAlt911: PropTypes.string,
  imageSrc1821: PropTypes.string,
  text71: PropTypes.string,
  name1: PropTypes.string,
  text9: PropTypes.string,
  imageSrc161: PropTypes.string,
  text22: PropTypes.string,
  imageAlt31: PropTypes.string,
  text211: PropTypes.string,
  text39: PropTypes.string,
  text1: PropTypes.string,
  imageSrc1721: PropTypes.string,
  imageAlt1231: PropTypes.string,
  text2: PropTypes.string,
  imageAlt1711: PropTypes.string,
  imageAlt141: PropTypes.string,
  imageSrc31: PropTypes.string,
  imageSrc17111: PropTypes.string,
  imageAlt161: PropTypes.string,
  imageAlt123: PropTypes.string,
  text15: PropTypes.string,
  imageSrc51: PropTypes.string,
  text12: PropTypes.string,
  rootClassName: PropTypes.string,
  imageSrc121121: PropTypes.string,
  imageAlt1221: PropTypes.string,
  text1212: PropTypes.string,
  imageAlt10221: PropTypes.string,
  imageAlt12221: PropTypes.string,
  text3: PropTypes.string,
  imageAlt131: PropTypes.string,
  imageSrc91: PropTypes.string,
  imageAlt1211: PropTypes.string,
  name51: PropTypes.string,
  imageSrc181: PropTypes.string,
  text20: PropTypes.string,
  imageSrc9111: PropTypes.string,
  text23: PropTypes.string,
  text7: PropTypes.string,
  imageSrc17121: PropTypes.string,
  text111: PropTypes.string,
  name21: PropTypes.string,
  text91: PropTypes.string,
  text81: PropTypes.string,
  text181: PropTypes.string,
  imageAlt71: PropTypes.string,
  text12111: PropTypes.string,
}

export default Flowambassador1
